// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero_hero__wzni9","logo":"hero_logo__2WLL6"};